<template>
  <v-layout
    class="stepper__wrapper text-ce"
    fill-height
    justify-center
    pa-4
    pt-0
    mb-3
    column
  >
    <v-flex xs12>
      <h2 class="header sz_dark_grey--text mt-3 mb-0">
        {{ $t('gift_giving_report.deliveryReport.title') }}
      </h2>
      <p
        v-if="deliveryReport"
        class="f-1 formatted-text"
      >
        {{ deliveryReport }}
      </p>
    </v-flex>
    <v-flex
      v-if="familyWords"
      xs12
    >
      <h2 class="header sz_dark_grey--text mt-3 mb-0">
        {{ $t('gift_giving_report.familyWords.title') }}
      </h2>
      <p class="f-1 formatted-text">
        {{ familyWords }}
      </p>
    </v-flex>
    <v-flex xs12>
      <h2 class="header sz_dark_grey--text mt-3 mb-0">
        {{ $t('gift_giving_report.volunteerWords.title') }}
      </h2>
      <p
        v-if="volunteerWords"
        class="f-1 formatted-text"
      >
        {{ volunteerWords }}
      </p>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
    name: 'ExamplePreview',
    props: {
        deliveryReport: {
            default: null
        },
        familyWords: {
            default: null
        },
        volunteerWords: {
            default: null
        }
    }
};
</script>

<style scoped>
.wrap-lines {
  white-space: pre-line;
  margin-top: -15px;
}
</style>
